const state = {
  status: "",
  token: localStorage.getItem("token") || "",
  user: {},
  defClub: null,
  usermenu: null,
  loading: false
};

export default state;
